var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"developing-box"},[_c('em',{staticClass:"el-icon-office-building"}),_c('div',{staticClass:"tip-text"},[_vm._v("功能建设中...")])])}]

export { render, staticRenderFns }